const PlusIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.14021 0.723848C7.68134 0.723849 7.30935 1.09583 7.30935 1.5547L7.30935 7.31173L1.55233 7.31173C1.09346 7.31173 0.721476 7.68371 0.721476 8.14258C0.721476 8.60144 1.09346 8.97343 1.55233 8.97343L7.30935 8.97343L7.30935 14.7305C7.30935 15.1893 7.68134 15.5613 8.14021 15.5613C8.59907 15.5613 8.97106 15.1893 8.97106 14.7305L8.97106 8.97343L14.7281 8.97343C15.1869 8.97343 15.5589 8.60144 15.5589 8.14258C15.5589 7.68371 15.1869 7.31173 14.7281 7.31173H8.97106L8.97106 1.5547C8.97106 1.09583 8.59907 0.723849 8.14021 0.723848Z"
      fill="black"
    />
  </svg>
);

export default PlusIcon;
